module.exports = __webpack_public_path__ + "static/media/8OLA17.2c63c345.jpg";